/*
	The store manages all application data.
	While this data is sourced from our API,
	we may have reason to manipulate it locally in order to...
		initiate a new request
		cleanup and format displays
		sanitize and map server communication
*/

// PRE-Auth
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import * as notifications from '@/qux-common/store/modules/notifications';
import * as account from '@/store/modules/account';
import * as api from '@/store/modules/api';
import * as application from '@/store/modules/application';
import * as client from '@/store/modules/client';

Vue.use(Vuex);

const vuexSessionStorage = new VuexPersist({
	key: 'vuex', // The key to store the state on in the storage provider.
	storage: window.sessionStorage, // or window.localStorage or localForage
	reducer: state => ({
		application: {
			debugMode: state.application.debugMode,
		},
		client: {
			list: state.client.list,
		},
		notifications: {
			notificationsList: state.notifications.notificationsList,
		},
	})
})

// State is simply the local data.
export default new Vuex.Store({
	modules: {
		account,
		api,
		application,
		client,
		notifications
	},
	plugins: [vuexSessionStorage.plugin]
});
